"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("../context");
exports.useCanvas = (contextKey) => {
    const subContext = context_1.useOsmosysCanvasPageContext();
    const { dispatchCanvasAction } = context_1.useOsmosysCanvasPageUpdateContext();
    if (!subContext[contextKey]) {
        throw new Error('Missing context');
    }
    return {
        data: subContext[contextKey],
        update: newVals => {
            dispatchCanvasAction({
                data: Object.assign(Object.assign({}, subContext[contextKey]), newVals),
                type: contextKey,
            });
        },
    };
};
//# sourceMappingURL=useCanvas.js.map